export interface ContextOptions {
  router: any
}

export let context: ContextOptions = {
  router: {},
}

export const initRequest = async (func: Function) => {
  context = func()
}
